import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const API = '/api/SalesProfile';

export interface SalesProfileResponseDto {
  answersJson: string;
  freeText: string | null;
  currentIndex: number;
  isCompleted: boolean;
  plan: SalesProfilePlan | null;
}

export interface SaveSalesProfileDto {
  answersJson: string;
  freeText: string;
  currentIndex: number;
  isCompleted: boolean;
}

export interface SalesProfilePlan {
  summary: string;
  track: string;
  sprintId: string | null;
  sprintName: string | null;
  sprintKind: string | null;
  focusAreas: {
    name: string;
    category: string;
    description: string;
    focusAreaId: string | null;
  }[];
}

export interface GenerateSalesProfilePlanDto {
  track: string;
  trackLabel: string;
  focusAreas: string[];
  motivations: string[];
  freeText: string | null;
}

@Injectable({ providedIn: 'root' })
export class SalesProfileService {
  constructor(private http: HttpClient) {}

  /** Returns the current user's saved response for the active tenant, or null. */
  getMine(): Observable<SalesProfileResponseDto | null> {
    return this.http.get<SalesProfileResponseDto | null>(`${API}/me`);
  }

  save(dto: SaveSalesProfileDto): Observable<SalesProfileResponseDto> {
    return this.http.post<SalesProfileResponseDto>(API, dto);
  }

  generatePlan(dto: GenerateSalesProfilePlanDto): Observable<SalesProfilePlan> {
    return this.http.post<SalesProfilePlan>(`${API}/plan`, dto);
  }

  /** Clears the current user's saved profile/plan for the active tenant. */
  reset(): Observable<unknown> {
    return this.http.post(`${API}/reset`, {});
  }

  /** Updates the current user's sales-profile plan summary text. */
  updateSummary(summary: string): Observable<unknown> {
    return this.http.put(`${API}/summary`, { summary });
  }
}
